module.exports = __webpack_public_path__ + "img/scene-stage-closed-curtain.9281082c.jpg";